import React from 'react';
import DrawSignature from 'ui/sections/notarize/pages/DrawSignature';
import { NotarizationStatus } from 'utils/enums';

export default class SpouseDrawSignature extends DrawSignature {
  static forSpouse = true;
  static notarizationSection = NotarizationStatus.SIGNATURE_CREATION_SPOUSE;
}
